enum ApiVersions {
  V1 = 'v1',
  V2 = 'v2',
}

export default ApiVersions;
